import {
	ENABLE_SCHEDULER_STATS,
	GQL_CACHING_REFRESH_DELAY,
	HTTP_CACHING_REFRESH_DELAY,
	INTERSECT_ROOT_MARGIN,
	LOGGING_ENABLED,
	METRICS_COMPONENT_INTERACTIVE_ENABLED,
	METRICS_TYPES,
	VALIDATE_SCHEMAS,
	ARIA_LIVE_ASSERTIVE_TIMEOUT,
	ARIA_LIVE_POLITE_TIMEOUT,
	WHEN_COMPONENT_IS_IDLE_TIMEOUT,
	WHEN_COMPONENT_IS_IDLE_THROTTLE,
	WHEN_COMPONENT_IS_IDLE_MIN_INTERVAL,
	METRICS_OBSERVER_INTERVAL,
	SCHEDULER_RAF_TIMEOUT,
	METRICS_MARK_PRUNING_INTERVAL,
	METRICS_MARK_EXPIRATION,
	METRICS_PRUNE_MARKS
} from '../constants';

export const testConfig = {};
// caching
testConfig[GQL_CACHING_REFRESH_DELAY] = 500;
testConfig[HTTP_CACHING_REFRESH_DELAY] = 500;

// Metrics
testConfig[METRICS_TYPES] = ['TEST'];
testConfig[ENABLE_SCHEDULER_STATS] = false;

// Intersection Observer
testConfig[INTERSECT_ROOT_MARGIN] = '400px';

// Logging
testConfig[LOGGING_ENABLED] = true;

// Validation
testConfig[VALIDATE_SCHEMAS] = true;

testConfig[METRICS_COMPONENT_INTERACTIVE_ENABLED] = true;

testConfig[ARIA_LIVE_ASSERTIVE_TIMEOUT] = 500;
testConfig[ARIA_LIVE_POLITE_TIMEOUT] = 5000;

testConfig[WHEN_COMPONENT_IS_IDLE_TIMEOUT] = 600;
testConfig[WHEN_COMPONENT_IS_IDLE_THROTTLE] = 50;
testConfig[WHEN_COMPONENT_IS_IDLE_MIN_INTERVAL] = 25;

testConfig[METRICS_OBSERVER_INTERVAL] = 3000;

testConfig[SCHEDULER_RAF_TIMEOUT] = 0;

testConfig[METRICS_MARK_PRUNING_INTERVAL] = 300000;
testConfig[METRICS_MARK_EXPIRATION] = 300000;
testConfig[METRICS_PRUNE_MARKS] = true;
